import React from 'react'
import PropTypes from 'prop-types'

import OptionPill from "./option-pill"
import OptionText from "./option-text"
import PopoverMenuSeparator from "../../../../gd-components/popover-menu/popover-menu/popover-menu-separator"
import PopoverMenuHeader from "../../../../gd-components/popover-menu/popover-menu/popover-menu-header"

// extends React.Component is required because of reference in parent
export default class SelectGenericPopoverOption extends React.Component {

    static propTypes = {
        option          : PropTypes.object,

        isHighlighted   : PropTypes.bool,
        isSelected      : PropTypes.bool,

        onClick         : PropTypes.func,
    }

    onClick = () => {this.props.onClick(this.props.option)}

    render() {
        if (this.props.option.type === 'separator') {
            return <PopoverMenuSeparator />
        }

        if (this.props.option.type === 'header') {
            return <PopoverMenuHeader title={this.props.option.title} />
        }

        const RenderComponent = !!this.props.option.color ? OptionPill : OptionText
        return <RenderComponent {...this.props} onClick={this.onClick}/>
    }
}